import { Component, Input, SimpleChanges } from '@angular/core';
import { AppointmentService } from '../services/appointment.service';

import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Appointment } from '../models/appointment.model';


@Component({
  selector: 'app-appointment-list-date',
  templateUrl: './appointment-list-date.component.html'
})
export class AppointmentListDateComponent {

  constructor(public service: AppointmentService, public datepipe: DatePipe) { }

  @Input() date: Date;

  ngOnChanges(changes: SimpleChanges) {

    this.date = changes.date.currentValue;
    this.onSearch();
  }

  ngOnInit() {
    this.onSearch();
  }

  onSearch() {
    this.service.list = null;
    this.service.currentPage = 1;
    this.service.modelSearch = new Appointment();
    this.service.modelSearch.fromDate = this.datepipe.transform(this.date, 'yyyy-MM-dd');
    this.service.modelSearch.toDate = this.service.modelSearch.fromDate
    this.service.search();
  }
}

